exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-button,\r\n.nav-button:focus {\r\n    text-transform: uppercase;\r\n    font-size: 13.7px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.17;\r\n    letter-spacing: 1.3px;\r\n    color: rgba(255, 255, 255, 0.92);\r\n    background-color: transparent;\r\n    cursor: pointer;\r\n    border: none;\r\n    outline: none;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    padding: 0.5rem;\r\n}\r\n.nav-button.selected {\r\n    color: #ffffff;\r\n    border-radius: 0;\r\n    border-bottom-color: red;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-nav-item/djiv-nav-item.component.css
// module id = ../../../../../src/app/shared/components/djiv-nav-item/djiv-nav-item.component.css
// module chunks = main